import styled from 'styled-components'

export const VideoItemDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  margin-left: 270px;
  padding: 8px;
  height: 100vh;
  background-color: ${props => (props.theme === true ? '#0f0f0f ' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    margin-left: 0px;
    margin-top: 50px;
    padding: 14px;
  }
`

export const VideoContainer = styled.div`
  height: 400px;
  width: 100%;
  margin-bottom: 10px;
  background-size: cover;
  @media screen and (max-width: 767px) {
    height: 250px;
  }
`

export const VideoItemDetailsDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const VideoItemDetailsTitle = styled.p`
  font-family: 'Roboto';
  margin-bottom: 7px;
  font-size: 15px;
  color: ${props => (props.theme === true ? '#ffffff' : '#231f20')};
`

export const VideoItemDetailsElContainer = styled.nav`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 767px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`
export const FirstContainer = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0px;
  margin: 0px;
`

export const DurationPara = styled.li`
  font-family: 'Roboto';
  font-size: 11px;
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
`

export const ViewsPara = styled(DurationPara)`
  list-style: none;
  margin-right: 18px;
`

export const SecondContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 767px) {
    margin: 0px;
  }
`

export const ReviewConatainer = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 11px;
  outline: none;
  cursor: pointer;
  border: none;
  background: transparent;
`
export const VideoItemDetailsLikeIcon = styled.i`
  font-size: 15px;
  margin-right: 4px;
  color: ${props => {
    if (props.isliked === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`

export const VideoItemDetailsDisLikeIcon = styled.i`
  font-size: 15px;
  margin-right: 4px;
  color: ${props => {
    if (props.isDisliked === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`
export const VideoItemDetailsSaveIcon = styled.i`
  font-size: 15px;
  margin-right: 4px;
  color: ${props => {
    if (props.isSaved === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`

export const ReviewLikePara = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  color: ${props => {
    if (props.isliked === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`

export const ReviewDisLikePara = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  color: ${props => {
    if (props.isDisliked === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`
export const ReviewSavePara = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  color: ${props => {
    if (props.isSaved === true) {
      return '#2563eb'
    }
    if (props.theme === true) {
      return '#7e858e'
    }
    return '#64748b'
  }};
`

export const HorizontalLine = styled.hr`
  background-color: ${props => (props.theme === true ? '#64748b' : '#94a3b8')};
  height: 2px;
  width: 100%;
  border: none;
  border-radius: 2px;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
`
export const VideoItemDetailsLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const VideoItemDetailsLogo = styled.img`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  margin-right: 20px;
  @media screen and (max-width: 767px) {
    height: 45px;
    width: 45px;
    margin-right: 10px;
  }
`
export const VideoItemDetailsChannelDetails = styled.div`
  display: flex;
  flex-direction: column;
`
export const VideoItemDetailsChannelName = styled.p`
  font-family: 'Roboto';
  font-size: 25px;
  font-weight: 800;
  margin-bottom: 10px;
  color: ${props => (props.theme === true ? '#ffffff' : '#212121')};
  @media screen and (max-width: 767px) {
    font-size: 15px;
    margin-bottom: 5px;
  }
`
export const VideoItemDetailsChannelSubscribers = styled.p`
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
  font-family: 'Roboto';
  font-size: 15px;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
    font-size: 10px;
  }
`
export const VideoItemDetailsChannelDescription = styled.p`
  color: ${props => (props.theme === true ? '#cccccc' : '#7e858e')};
  font-family: 'Roboto';
  font-size: 14px;
  margin-bottom: 30px;
  @media screen and (max-width: 767px) {
    margin-bottom: 15px;
    font-size: 11px;
  }
`
